import { render, staticRenderFns } from "./buy-now-new-account-reminder.vue?vue&type=template&id=355e4eee&scoped=true&"
import script from "./buy-now-new-account-reminder.vue?vue&type=script&lang=js&"
export * from "./buy-now-new-account-reminder.vue?vue&type=script&lang=js&"
import style0 from "./buy-now-new-account-reminder.vue?vue&type=style&index=0&id=355e4eee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e4eee",
  null
  
)

export default component.exports